import type { ReactElement } from "react";
import { useRef, useState } from "react";

import { PlainTooltip } from "@similarweb/ui-components";
import type { TextProps } from "@similarweb/ui-components/foundations";
import { Text } from "@similarweb/ui-components/foundations";

import { useMount } from "app/custom-hooks/useMount";

import { StyledConditionalTooltipTextContainer } from "./styles";

const MAX_WIDTH = 300;
const TOOLTIP_DEBOUNCE = 600;

interface IConditionalTooltipTextProps extends Omit<TextProps, "children"> {
    children: string;
}

export const ConditionalTooltipText = (props: IConditionalTooltipTextProps): ReactElement => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLSpanElement>(null);

    const [isEnabled, setIsEnabled] = useState(false);

    useMount(() => {
        const wrapperWidth = wrapperRef.current?.offsetWidth || 0;
        const contentWidth = contentRef.current?.offsetWidth || 0;

        if (!isEnabled && wrapperWidth <= contentWidth) {
            setIsEnabled(true);
        }
    });

    return (
        <PlainTooltip
            enabled={isEnabled}
            allowHover
            debounce={TOOLTIP_DEBOUNCE}
            tooltipContent={props.children}
            maxWidth={MAX_WIDTH}
        >
            <div>
                <StyledConditionalTooltipTextContainer ref={wrapperRef}>
                    <span ref={contentRef}>
                        <Text {...props}>{props.children}</Text>
                    </span>
                </StyledConditionalTooltipTextContainer>
            </div>
        </PlainTooltip>
    );
};
